import { EGGSHELL_CREW, GREEN_CREW, Product, SOCKS } from '../products';

const sageHatRecos: Product[] = [
    EGGSHELL_CREW, 
    GREEN_CREW,
    SOCKS,
];

export default sageHatRecos;